import { FC, useContext, useMemo, useCallback } from 'react';
import BtnAdd from '../../../buttons/btnAdd.component/BtnAdd';
import { TaskAddEditContext } from '../../../../contexts/TaslAddEditFormContext';
import { fullNameFormat, initials } from '../../../../helpers/Inicials';
import PersonLineDisplay from '../../../Shared/PersonLineDisplay';
import PersonSelector from '../../../Shared/PersonSelector/PersonSelector';
import ExitCross from "../../../../assets/cancelGreey.svg";
import { IUserMinimal } from '../../../../common/api_interfaces/user/IUserMinimal';

const SubscribersFormTab: FC = () => {
    const taskAddEditFormContext = useContext(TaskAddEditContext);

    const showGroupSelector = useMemo(() => 
        taskAddEditFormContext.showGroupSelector,
        [taskAddEditFormContext.showGroupSelector]
    );

    const handleGroupRemove = useCallback((userId: number) => {
        taskAddEditFormContext.handleGroupRemove(userId);
    }, [taskAddEditFormContext.handleGroupRemove]);

    const handleGroupSelection = useCallback((person: number) => {
        taskAddEditFormContext.handleGroupSelection(person);
    }, [taskAddEditFormContext.handleGroupSelection]);

    const closeGroupSelector = useCallback(() => {
        taskAddEditFormContext.closeGroupSelector();
    }, [taskAddEditFormContext.closeGroupSelector]);

    const openGroupSelector = useCallback(() => {
        taskAddEditFormContext.openGroupSelector();
    }, [taskAddEditFormContext.openGroupSelector]);

    const filteredMembers = useMemo(() => {
        return taskAddEditFormContext.persons
            .filter(xx => 
                !taskAddEditFormContext.group.some(yy => yy.id === xx.id)
            )
            .map(person => ({
                id: person.id,
                role: person.roleName,
                name: fullNameFormat(person, "s N M"),
                surname: "",
                middleName: "",
                photoId: person.photoId,
            }));
    }, [taskAddEditFormContext.persons, taskAddEditFormContext.group, taskAddEditFormContext.responsible]);

    const renderSubscriber = useCallback((user: IUserMinimal) => {
        const userName = user.name
            ? fullNameFormat(user, "s N M")
            : initials((user as any).responsibleName);

        return (
            <div
                className="task__create--edit__form--tab__panel--type__block--group"
                key={user.id}
                title={initials(user.name)}
            >
                <PersonLineDisplay
                    name={userName}
                    userId={user.id}
                />
                <div
                    className="task__create--edit__form--tab__panel--type__block--delete"
                    onClick={() => handleGroupRemove(user.id)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && handleGroupRemove(user.id)}
                    aria-label={`Удалить ${userName} из подписчиков`}
                >
                    <img src={ExitCross} alt="Удалить подписчика" />
                </div>
            </div>
        );
    }, [handleGroupRemove]);

    return (
        <div className="task__create--edit__form--tab__panel--type__task--all">
            <div className="task__create--edit__form--tab__panel--type__task">Подписчики</div>
            <div className="task__create--edit__form--tab__panel--type__block">
                <div>
                    <BtnAdd 
                        type="gd563grt433" 
                        onClickFunc={openGroupSelector} 
                        permission={true} 
                    />
                </div>
                <div className="selected-group-conatiner">
                    {taskAddEditFormContext.group.map(renderSubscriber)}
                </div>
            </div>
            
            {showGroupSelector && (
                <div style={{ position: "relative", top: "70px" }}>
                    <div
                        style={{ opacity: "0.5" }}
                        className="full-screen-overlay__group"
                        onClick={closeGroupSelector}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && closeGroupSelector()}
                        aria-label="Закрыть выбор подписчиков"
                    />
                    <PersonSelector
                        updateFilters={() => {}}
                        loadPage={taskAddEditFormContext.appendPersons}
                        scrollEnded={false}
                        members={filteredMembers}
                        selectPerson={handleGroupSelection}
                        projectId={taskAddEditFormContext.projectId}
                    />
                </div>
            )}
        </div>
    );
};

export default SubscribersFormTab;